<template>
    <div class="current-company-info-container mr-3">
        <template v-for='company in companies'>
            <div v-if="company.company_id == company_id">
                <div class="company-logo-container d-flex align-items-center">
                    <span class="mr-3 font-semi-bold">{{ company.company_name }}</span>
                    <img :src="$api_url+'/images/company/'+company.company_logo" class="img-fluid">
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    export default{
        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
        },
        data(){            
            
            return {               
                
                companies: [],

                company_logo: null,                
                company_name:null,
                company_id:null,
                selected:null,
                
            }
        },
        methods:{
            getEmployeeCompanies: function()
            {
                axios.get(this.$api_url+'/employee/company/list' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.companies = response.data;
                    this.getCurrentCompany();
                }.bind(this));
            },
            getCurrentCompany: function()
            {
                axios.get(this.$api_url+'/front/company/publicinfo' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){         
                    //console.log(response.data);           
                    this.company_logo = response.data.logo;
                    this.company_name = response.data.name;
                    this.company_id = response.data.id;
                    this.selected = this.company_id;
                }.bind(this));
            },
            selectCompany:function(x , y)
            {               
                let formData = new FormData();
                formData.append('company_id', x);
                formData.append('employee_id', y);
                
                axios.post(this.$api_url+'/employee/setcompany', formData)
                                .then(function (response) 
                                {         
                                    this.$cookies.set("last_clicked_component" ,"employee-dashboard");                                                           
                                    //window.location.href = this.$api_url+'/company/dashboard';
                                    window.location.reload(true);
                                    
                                }.bind(this)).catch(function (error){currentObj.serverError(error);});

            },
            

        },
        created: function(){
            this.getEmployeeCompanies();
        }
    }
</script>
